// extracted by mini-css-extract-plugin
export default {"statusNote":"statusNote-DiX_XVjj"};